import { Card, CardContent } from "@altimateai/lego";
import { useConversationGroupContext } from "./context/ConversationsProvider";
import ConversationHeader from "./ConversationHeader";
import { Conversation } from "./context/types";
import { DbtDocsShareDetails } from "../types";
import { useMemo } from "react";

interface Props {
  conversation: Conversation;
  shareId: DbtDocsShareDetails["share_id"];
}
const ConversationComponent = ({ conversation, shareId }: Props) => {
  const { users } = useConversationGroupContext();
  const user = useMemo(() => {
    if (!conversation?.user_id) {
      return;
    }

    return users[conversation.user_id];
  }, [conversation.user_id, users]);

  return (
    <Card>
      <ConversationHeader
        user={user}
        timestamp={conversation.timestamp}
        shareId={shareId}
      />
      <CardContent>
        <p>{conversation.message.replace(/@\[(.*?)\]\((.*?)\)/g, "@$2")}</p>
      </CardContent>
    </Card>
  );
};

export default ConversationComponent;
